'use strict';

var Features = function(config) {

  var self = this;
  var $contentEl = $(config.content);
  var $templateEl = $(config.template);
  var $container = $(config.container);
  var $feature = $(config.feature);

  self.checkCurrFeatures = function(slug) {

    var canCreateFeature = true;

    $feature.each(function() {
      var $this = $(this);
      var _slug = $this.attr('data-menu-item-slug');

      if (_slug === slug) {
        canCreateFeature = false;
        return false;
      }
    });

    return canCreateFeature;
  }

  self.parseContent = function() {
    $contentEl.each(function() {
      var $this = $(this);
      var slug = $this.attr('data-menu-item-slug');
      var content = JSON.parse($this.text());
      var canCreateFeature = self.checkCurrFeatures(slug);

      if (canCreateFeature) {
        self.parseTemplates(slug, content);
      }
    });
  }

  self.parseTemplates = function(slug, content) {
    $templateEl.each(function() {
      var $this = $(this);
      var _slug = $this.attr('data-menu-item-slug');

      if (_slug === slug) {
        var _template = $this.html();
        self.parseContainers(slug, _template, content)
      }
    });
  }

  self.parseContainers = function(slug, _template, content) {
    $container.each(function() {
      var $this = $(this);
      var _slug = $this.attr('data-menu-item-slug');

      if (_slug === slug) {
        self.appendFeature($this, _template, content)
      }
    });
  }

  self.newFeature = function(_template, content) {
    var feature = _.template(_template);
    return $(feature({content: content}));
  }

  self.appendFeature = function(_$container, _template, content) {
    var $feature = self.newFeature(_template, content);
    _$container.append($feature);
  }

  self.init = function() {
    self.parseContent();
  }
};

module.exports = Features;
